import { Link } from 'react-router-dom';
import { categories } from '@/mocks/homeData';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-white">
      <div className="max-w-[1440px] mx-auto px-4 md:px-10 pt-14 pb-8">
        <div className="mb-10">
          <h2 className="text-3xl md:text-4xl font-heading font-bold tracking-tight text-white">
            OOPBUY Spreadsheet
          </h2>
          <p className="mt-4 text-sm text-white/60 max-w-md leading-relaxed">
            Der vertrauensw&uuml;rdige Einkaufsassistent f&uuml;r den DACH-Raum. Entdecken Sie die besten Shopping-Links,
            QC-Checks und Versandinformationen &ndash; alles auf Deutsch.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-12">
          <div>
            <h3 className="text-xs font-semibold uppercase tracking-widest text-white/50 mb-4">Beliebte Kategorien</h3>
            <div className="grid grid-cols-2 gap-2">
              {categories.slice(0, 8).map((cat) => (
                <a
                  key={cat.name}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-white/70 hover:text-white transition-colors whitespace-nowrap"
                >
                  {cat.name}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-xs font-semibold uppercase tracking-widest text-white/50 mb-4">Ratgeber &amp; Guides</h3>
            <div className="flex flex-col gap-2">
              <Link to="/artikel/oopbuy-spreadsheet-guide" className="text-sm text-white/70 hover:text-white transition-colors">
                OOPBUY Spreadsheet Guide
              </Link>
              <Link to="/artikel/oopbuy-spreadsheet-anfaenger" className="text-sm text-white/70 hover:text-white transition-colors">
                F&uuml;r Anf&auml;nger
              </Link>
              <Link to="/artikel/oopbuy-spreadsheet-versand" className="text-sm text-white/70 hover:text-white transition-colors">
                Versand Guide
              </Link>
              <Link to="/artikel/oopbuy-spreadsheet-qc-check" className="text-sm text-white/70 hover:text-white transition-colors">
                QC-Check Guide
              </Link>
              <Link to="/artikel/oopbuy-spreadsheet-sicherheit" className="text-sm text-white/70 hover:text-white transition-colors">
                Sicherheit
              </Link>
              <Link to="/artikel/oopbuy-spreadsheet-coupons" className="text-sm text-white/70 hover:text-white transition-colors">
                Coupons &amp; Rabatte
              </Link>
              <Link to="/artikel/oopbuy-spreadsheet-vergleich" className="text-sm text-white/70 hover:text-white transition-colors">
                Agenten-Vergleich
              </Link>
              <Link to="/artikel/oopbuy-spreadsheet-sneaker" className="text-sm text-white/70 hover:text-white transition-colors">
                Sneaker Guide
              </Link>
            </div>
          </div>

          <div>
            <h3 className="text-xs font-semibold uppercase tracking-widest text-white/50 mb-4">N&uuml;tzliche Links</h3>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-white/70 hover:text-white transition-colors">
                Startseite
              </Link>
              <Link to="/artikel/oopbuy-spreadsheet-weidian" className="text-sm text-white/70 hover:text-white transition-colors">
                Weidian Guide
              </Link>
              <Link to="/artikel/oopbuy-spreadsheet-taobao" className="text-sm text-white/70 hover:text-white transition-colors">
                Taobao Guide
              </Link>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="text-sm text-white/70 hover:text-white transition-colors"
              >
                kaspreadsheet.com
              </a>
            </div>

            <div className="flex items-center gap-4 mt-6">
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="w-9 h-9 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 transition-colors cursor-pointer">
                <i className="ri-global-line text-white"></i>
              </a>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="w-9 h-9 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 transition-colors cursor-pointer">
                <i className="ri-shopping-bag-line text-white"></i>
              </a>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="w-9 h-9 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 transition-colors cursor-pointer">
                <i className="ri-star-line text-white"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/40">
            &copy; {new Date().getFullYear()} OOPBUY Spreadsheet. Alle Rechte vorbehalten.
          </p>
          <div className="flex items-center gap-6">
            <Link to="/" className="text-xs text-white/40 hover:text-white/70 transition-colors">
              Impressum
            </Link>
            <Link to="/" className="text-xs text-white/40 hover:text-white/70 transition-colors">
              Datenschutz
            </Link>
            <Link to="/" className="text-xs text-white/40 hover:text-white/70 transition-colors">
              Kontakt
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}